import { DepartmentsEnum } from '@moonpig/web-shared-types-graphql/graphqlTypes'
import { ProductInfoProduct } from '../../types'
import { useProductsLocaleText } from '../../locale'

type Args = {
  product: ProductInfoProduct
  productType: string | undefined
  groupCardProjectId: string | undefined
  localiseText: ReturnType<typeof useProductsLocaleText>
}

export const getPrimaryButtonText = ({
  product,
  productType,
  groupCardProjectId,
  localiseText,
}: Args): string => {
  const isCustomisable =
    product.customisable ||
    product.category.department === DepartmentsEnum.DIGITAL_GIFTS

  if (isCustomisable) {
    if (productType === 'groupCard') {
      return localiseText('group_card.make_group_card')
    }
    return groupCardProjectId
      ? localiseText('common.next')
      : localiseText('common.personalise')
  }

  return localiseText('common.add_to_basket')
}
